 
import WebOffice from '../../../webOffice/index'; 

export default{
    components: {//自定义组件列表 
        'web-office':WebOffice
        
	},
    data() {
        
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'交办任务列表', path:''
            },{
                name:'交办任务详情', path:''
            }],
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/task/save',//保存
                bykey:'oa/official/task/byKey',//详情
                fileNumList:'oa/fn/cfg/list', //文号配置列表
                getFileNum:'oa/fn/cfg/getFileNum',
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务
            }, 
            editObj:{
                title:"",  
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"",
            fileList:[],//源文件
            enclosureList:[],//附件 
            userWnd: false,//是否显示人员选择窗口
            rules:{ 
                title:[{ required: true, message: '请输入标题', trigger: 'blur' }], 
            },
            fileNumList:[],
            leadWnd:false,
            WFtask:{}, 
            webShow: false,
            docFileKey:'',
            fileType:".docx",
            drawer:false
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey: String,
        taskKey: String, 
    },
    
    watch: {
        bizKey() {
            this.init();
        }, 
    }, 
    mounted() {  
        this.init(); 
    },                              
    methods: {
        init() {
            this.key = this.bizKey;
            let taskKey = this.taskKey;
            if (this.key > -1) {
                this.find();
            }
            if (taskKey > -1) {
                this.getWfTask(taskKey);
            }
        },
        getWfTask(taskKey){ 
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this;
            me.key = me.bizKey;
            me.$post({
                url: me.apis.bykey,
                params:me.key,  
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj;
                    me.fileList.push(rsp.retObj.fileInfo);
                    me.enclosureList=rsp.retObj.enclosureList;
                    me.$delete(me.editObj,'fileInfo');
                    me.$delete(me.editObj,'enclosureList');
                }
            })
        },
         
        goBack(){ 
            this.$router.go(-1);
        }, 
        
        handlePreview(file){ 
            if(file.path){
                if(file.path.includes(".docx")||file.path.includes(".xlsx")||file.path.includes(".doc")||file.path.includes(".xls")){
                    // this.docFileKey=file.id;
                    // this.fileType=file.path.substring(file.path.lastIndexOf("."),file.path.length);
                    // this.webShow=true;

                    let {href}  = this.$router.resolve({ 
                        path: "/oa/office/browerDialog",
                        query:{
                            isView:1,
                            bizKey:this.key,
                            fileType:file.path.substring(file.path.lastIndexOf("."), file.path.length),
                            bizType:6,
                            fileId:file.id 
                        }
                    })    
                    this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
              
                }else if(file.path.includes(".txt") ||file.path.includes(".pdf") || file.path.includes(".PDF") || file.path.includes(".png") || file.path.includes(".PNG")|| file.path.includes(".jgp") || file.path.includes(".JPG")|| file.path.includes(".gif") || file.path.includes(".GIF")){
                    const url = this.$global.baseUrl + file.path;
                    window.open(url, '_blank');
                }  
                else{
                    const url = this.$global.baseUrl + 'sh/file/download?id=' + file.id;
                    window.open(url, '_blank');
                }
            } 
        }, 
        downloadFile(row){
            const url = this.$global.baseUrl + 'sh/file/download?id=' + row.id;
            window.open(url, '_blank');
        },
        downloadAll(){
            const url = this.$global.baseUrl +"oa/official/downloadFileAll?bizKey=" + this.key;
            window.open(url, '_blank');
           
        },
        callback(){

        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/task/view/view.js